export default {
    plainTextPlaceholder: 'Type your answer here',
    plainTextTooltip:
        'Press Enter to go to the next question.\nShift+Enter to add a new paragraph.',
    successTitle: 'Your answer have been submitted successfully',
    successButtonLabel: 'Home',
    closePreview: 'Close preview',
    closeWindow: 'You may now close the window.',
    evaluationClosed: {
        pill: 'Evaluation Closed',
        title: 'This evaluation is no longer available',
        description:
            'The deadline for this evaluation has passed or the evaluation has been deleted. You can no longer submit or update your answers.',
        errorTitle: 'Evaluation Unavailable',
        errorMessage:
            'This evaluation is no longer available. You can no longer submit or update your answers.',
    },
    alreadyAnswered: {
        pill: 'Evaluation submitted',
        title: 'You have already answered this evaluation',
        description: 'Answers can no longer be edited once they have been submitted.',
    },
    unavailable: {
        pill: 'Evaluation not found',
        title: 'This evaluation is not available.',
        description:
            'The link you opened does not lead to any evaluation. Open the evaluation from its invitation link.',
    },
};
